import { gql } from '@apollo/client'
import { SaleCreateError } from './sale_create'

export interface LinkSaleAddressMutationData {
  billingAddressId: string
  shippingAddressId: string
  saleId: string
  customerId: string
}

export interface LinkSaleAddressMutationResponse {
  LinkSaleAddress: {
    created?: boolean
    error?: Pick<SaleCreateError, 'message'>
  }
}

export const linkSaleAddressMutation = gql`
  mutation LinkSaleAddressMutation($input: LinkSaleAddressInput!) {
    linkSaleAddress(input: $input) {
      created
      error {
        message
      }
    }
  }
`
